import Vue from 'vue'

import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)

import Vue2TouchEvents from 'vue2-touch-events'
Vue.use(Vue2TouchEvents)

import App from './App.vue'
import router from './router'
import '@/assets/scss/style.scss'
import i18n from './i18n/i18n'
import vueVimeoPlayer from 'vue-vimeo-player'
import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
  config: { id: 'G-XYXK9LH6X7' },
  params: {
    send_page_view: false,
  },
})

Vue.use(vueVimeoPlayer)

// import * as Sentry from "@sentry/vue";
// import { Integrations } from "@sentry/tracing";
// Sentry.init({
//   Vue,
//   dsn: "https://a9a2f685d56c476598f30fc3f27c0316@o295305.ingest.sentry.io/5985734",
//   integrations: [
//     new Integrations.BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracingOrigins: ["localhost", "my-site-url.com", /^\//],
//     }),
//   ],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// });

Vue.config.productionTip = false

new Vue({
  router,
  render: (h) => h(App),
  i18n,
}).$mount('#app')
